module.exports = __webpack_public_path__ + "assets/b16.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b16.png
// module id = 601
// module chunks = 0